import styled from '@emotion/styled'

const StyledContainer = styled.input``

export default StyledContainer
